import React, {memo} from "react";
import BaseModal from "./../BaseModal";
import {useDispatch, useSelector} from "react-redux";

import {CSSTransition, SwitchTransition} from "react-transition-group";

import {Modal, Button, Col, Form, Row} from "react-bootstrap";
import qs from "querystring";
import axios from "axios";
import {BASE_URL, URL_ORDER_EDIT_DESC_GRATUITY} from "../../../../../apis";
import LoaderModals from "../../loaders/LoaderModals";
import SwiperCore, {Navigation, Scrollbar, A11y} from 'swiper';



import {
    handelCloseModalEditDescGratuity, 
    handelToggleLoaderModalDescGratuity,
    actionChangeInputsModalEditOrderDescGratuity, 
    actionChangeGratuityModalEditOrderDescGratuity
} from "../../../../../redux/actions/modals/editOrder/modalEditDescGratuity";
import {actionChangeSelectOrderModalInvoice} from "../../../../../redux/actions/modals/modalInvoice/modalInvoice"; 
import swal from 'sweetalert';



import {
    actionChangeHandelModalAddPGratuity,
    actionChangeInputsModalAddGratuity
} from "../../../../../redux/actions/modals/modalGratuity/modalGratuity";


SwiperCore.use([Navigation, Scrollbar, A11y]);
const EditOrderDescGratuityModal = () => {
    const dispatch = useDispatch();


    const {statusShow, loader_modal, orderDescription, gratuity} = useSelector(state => state.modalEditOrderDescGratuity);
    const {order} = useSelector(state => state.modalInvoice);
    const {token} = useSelector(state => state.user);




    
    const handleClose = () => {
        dispatch(handelCloseModalEditDescGratuity());
    };


    const handleSubmit = () => {
        dispatch(handelToggleLoaderModalDescGratuity(true));

        callApiEditOrderDescGratuity();
    };


    const callApiEditOrderDescGratuity = () => {
        let data = {order: order.order, gratuity: gratuity, description: orderDescription};
        
        axios({
            method: 'post',
            url: BASE_URL + URL_ORDER_EDIT_DESC_GRATUITY,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token,
            },
            data: qs.stringify(data),
        }).then((response) => {
            dispatch(handelToggleLoaderModalDescGratuity(false));

            if(response.data.status === "ok") {
                let editOrder = order;
                editOrder.order_description = orderDescription;
                editOrder.gratuity = gratuity;
                dispatch(actionChangeSelectOrderModalInvoice(editOrder));


                if(response.data.message !== undefined && response.data.message !== null)
                    swal({
                        text: response.data.message,
                        buttons: {
                            cancel: "باشه",
                        },
                        icon: "success",
                    }).then(function() {
                        dispatch(handelCloseModalEditDescGratuity());
                    });
                else
                    dispatch(handelCloseModalEditDescGratuity());
            }
            else if(response.data.status === "error")
                swal({
                        text: response.data.message,
                        buttons: {
                            cancel: "باشه",
                        },
                        icon: "error",
                    });
        }).catch((error) => {
            dispatch(handelToggleLoaderModalDescGratuity(false));
        });
    };

    


    const handelChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(actionChangeInputsModalEditOrderDescGratuity(name, value));
    };


    const handelSelectableQuestion = (question, answerId, answerTitle) => {

        if(question === 'reward' ) {
            if(answerId !== 4) { // mablaghe delkhah nabashe
                dispatch(actionChangeInputsModalAddGratuity('price', '')); // meghdare inpute modale ezafe kardane aname delkhah khali beshe
                if(answerTitle === "صفر")
                    dispatch(actionChangeGratuityModalEditOrderDescGratuity("0"));
                else
                    dispatch(actionChangeGratuityModalEditOrderDescGratuity(answerTitle));
            }
            else 
                dispatch(actionChangeHandelModalAddPGratuity(true));
        }
    };

    let default_gratuity = ["0", "5000", "10000"];
    return  (
        <React.Fragment>
            <BaseModal title='ویرایش توضیحات و انعام'
                       show={statusShow}
                       dialogClassName={'modal-dialog-shopping-card-custom'}
                       handleClose={handleClose}>
                <Modal.Body>
                    {!loader_modal ?

                        <SwitchTransition mode={'out-in'}>
                            <CSSTransition
                                key={false}
                                addEndListener={(node, done) => {
                                    node.addEventListener("transitionend", done, false);
                                }}  >
                                <div className={"o-hidden"}>
                                    <div className={'anim-base-test'}>





                                        <React.Fragment>
                                            <div className={'box-questions-body-modal-shopping-card'}>
                                                <div className={'box-add-description'}>
                                                    <Form.Group controlId="add-description">
                                                        <Form.Label>افزودن توضیحات سفارش</Form.Label>
                                                        <Form.Control as="textarea" rows="3"
                                                                      name={'orderDescription'}
                                                                      value={orderDescription}
                                                                      onChange={handelChangeInputs}
                                                                      placeholder={'میتوانید در این قسمت برای شاپر خود توضیحاتی اضافه کنید...'}/>
                                                    </Form.Group>
                                                </div>

                                                <div className={'list-questions-modal-shopping-card'}>
                                                    <div className={'item-questions-modal-shopping-card'}>
                                                        <h6>انعام دلخواه (تماما متعلق به خریدار سفارش شما)</h6>
                                                        <Row>
                                                            {
                                                                [
                                                                    {id: 1, title: 'صفر', default: (gratuity === '0' ? true : false), question: 'reward', value: 0},
                                                                    {id: 2, title: '5000', default: (gratuity === '5000' ? true : false), question: 'reward', value: 5000},
                                                                    {id: 3, title: '10000', default: (gratuity === '10000' ? true : false), question: 'reward', value: 10000},
                                                                    {
                                                                        id: 4,
                                                                        title: 'مبلغ دلخواه',
                                                                        default: (gratuity !== '' && gratuity !== '0' && gratuity !== '5000' && gratuity !== '10000' && gratuity !== 0 ? true : false),
                                                                        question: 'reward',
                                                                        value: gratuity !== '' && gratuity !== '0' && gratuity !== '5000' && gratuity !== '10000' && gratuity !== 0  ? gratuity : 0
                                                                    },
                                                                ].map(answer => {
                                                                    let selectItem = answer.default;
                                                                    /*for (const key in selectableQuestion) {
                                                                        if (typeof selectableQuestion[key].question !== 'undefined'
                                                                            && selectableQuestion[key].question === answer.question) {
                                                                            selectItem = selectableQuestion[key].answerId === answer.id;
                                                                        }
                                                                    }*/
                                                                    return (
                                                                        <Col xs={6} className={'mt-1'} key={answer.id}>
                                                                            <Button variant="success"
                                                                                    onClick={() => handelSelectableQuestion(answer.question, answer.id, answer.title)}
                                                                                    className={`base-btn-green-border ${selectItem ? 'select-btn-answer' : ''}`}
                                                                                    block>
                                                                                {(answer.title === 'صفر')
                                                                                    ? answer.title //اگر صفر بود
                                                                                    : (answer.title === 'مبلغ دلخواه')
                                                                                        ? gratuity !== '' && !default_gratuity.includes(gratuity) ? parseInt(gratuity).toLocaleString() + ' تومان' : answer.title //مبلغ دلخواه
                                                                                        : parseInt(answer.title).toLocaleString() + ' تومان' // اگر تومان بود
                                                                                }
                                                                            </Button>
                                                                        </Col>
                                                                    )
                                                                })
                                                            }
                                                        </Row>
                                                    </div>
                                                    {/*questions.length > 0 ?
                                                        questions.map((question) => {
                                                            return (
                                                                <div className={'item-questions-modal-shopping-card'} key={question.id}>
                                                                    <h6>{question.title}</h6>
                                                                    <Row>
                                                                        {
                                                                            question.answers.map(answer => {
                                                                                let selectItem = parseInt(answer.default) === 1;
                                                                                for (const key in selectableQuestion) {
                                                                                    if (typeof selectableQuestion[key].question !== 'undefined'
                                                                                        && selectableQuestion[key].question === question.title) {
                                                                                        selectItem = selectableQuestion[key].answerId === answer.id;
                                                                                    }
                                                                                }
                                                                                return (
                                                                                    <Col xs={6} className={'mt-1'} key={answer.id}>
                                                                                        <Button variant="success"
                                                                                                onClick={() => handelSelectableQuestion(question.title, answer.id, answer.title)}
                                                                                                className={`base-btn-green-border ${selectItem ? 'select-btn-answer' : ''}`}
                                                                                                block>{answer.title}</Button>
                                                                                    </Col>
                                                                                )
                                                                            })
                                                                        }
                                                                    </Row>
                                                                </div>
                                                            );
                                                        })
                                                        : ''*/}
                                                </div>
                                            </div>
                                        </React.Fragment>




                                    </div>
                                </div>
                            </CSSTransition>
                        </SwitchTransition>

                                        
                        :<LoaderModals/>}
                </Modal.Body>
                <Modal.Footer>
                    <Row className={'w-100 m-auto'}>
                        <Col xs={6} className={'mt-1'}>
                            <Button variant="success" className={'base-btn-green'} block onClick={handleSubmit}>
                                <span>تایید</span>
                            </Button>
                        </Col>
                        <Col xs={6} className={'mt-1'}>
                            <Button variant="success" className={'base-btn-green-border'} block onClick={handleClose}>
                                <span>انصراف</span>
                            </Button>
                        </Col>

                    </Row>
                </Modal.Footer>
            </BaseModal>
        </React.Fragment>
    )
};

export default memo(EditOrderDescGratuityModal);
